import { DocumentTypeEnum } from '@workalizer/shared/enums';
export var getDriveLinkByType = function (type, slugId) {
    if (!slugId) {
        throw new Error('Invalid or missing slugId');
    }
    switch (type) {
        case DocumentTypeEnum.SPREADSHEET:
            return "https://docs.google.com/spreadsheets/d/".concat(slugId);
        case DocumentTypeEnum.DOCUMENT:
            return "https://docs.google.com/document/d/".concat(slugId);
        case DocumentTypeEnum.PRESENTATION:
            return "https://docs.google.com/presentation/d/".concat(slugId);
        case DocumentTypeEnum.DRAWING:
            return "https://docs.google.com/drawings/d/".concat(slugId);
        case DocumentTypeEnum.FOLDER:
            return "https://drive.google.com/drive/folders/".concat(slugId);
        case DocumentTypeEnum.FORM:
            return "https://docs.google.com/forms/d/".concat(slugId);
        case DocumentTypeEnum.PHOTO:
        case DocumentTypeEnum.VIDEO:
        case DocumentTypeEnum.AUDIO:
        case DocumentTypeEnum.PDF:
            return "https://drive.google.com/file/d/".concat(slugId, "/view");
        case DocumentTypeEnum.SHORTCUT:
            return "https://drive.google.com/drive/u/0/folders/".concat(slugId);
        case DocumentTypeEnum.SCRIPT:
            return "https://script.google.com/d/".concat(slugId);
        case DocumentTypeEnum.SITE:
            return "https://".concat(slugId, ".sites.google.com");
        case DocumentTypeEnum.MAP:
            return "https://www.google.com/maps/d/u/0/edit?mid=".concat(slugId);
        case DocumentTypeEnum.BINARY:
        case DocumentTypeEnum.OTHER:
        default:
            return "https://drive.google.com/file/d/".concat(slugId);
    }
};
